import { IProjectFollowership } from "@api/schema"

/*
 * FollowershipHelper: Class with helper-functions for the followership-context
 */
export class FollowershipHelper {

  /**
   * creates a standardized unique string to be used as usecaseKey for API-calls
   * for deleting of ProjectFollowerships (unfollow usecase).
   *
   * @param projectFollowership the followerhip
   * @returns a unique string to be used as usecaseKey
   */
  static usecaseKeyForUnfollowProject = (projectFollowership: IProjectFollowership): string =>
    // we allow projectFollowership to be null
    `followership_unfollow_${projectFollowership?.["@id"]}`
}